/**
 * @module cercaliagl/control/MapControls
 */
/**
 * Options available for controls.<br/>
 * <ul>
 *  <li><b>cercaliagl.control.MapControls.ADDRESS</b>: Control address. Value: <code>address</code></li>
 *  <li><b>cercaliagl.control.MapControls.BUILDINGS3D</b>: Control for 3D buildings. Value: <code>buildings3d</code></li>
 *  <li><b>cercaliagl.control.MapControls.CLEAN</b>: Clean button control. Value: <code>clean</code></li>
 *  <li><b>cercaliagl.control.MapControls.FULLSCREEN</b>: Full screen control. Value: <code>fullscreen</code></li>
 *  <li><b>cercaliagl.control.MapControls.GAS_STATIONS</b>: Gas stations control. Value: <code>gasstations</code></li>
 *  <li><b>cercaliagl.control.MapControls.INFOMAP</b>: Info map control for internal purposes. Value: <code>infomap</code></li>
 *  <li><b>cercaliagl.control.MapControls.ISOCHRONES</b>: Logistics restrictions control. Value: <code>isochrones</code></li>
 *  <li><b>cercaliagl.control.MapControls.LAYER_REGIONS</b>: Layer regions control. Value: <code>layerregions</code></li>
 *  <li><b>cercaliagl.control.MapControls.LAYER_SWITCHER</b>: Layer switcher control. Value: <code>layerswitcher</code></li>
 *  <li><b>cercaliagl.control.MapControls.LOGISTICS_RESTRICTIONS</b>: Logistics restrictions control. Value: <code>logisticsrestrictions</code></li>
 *  <li><b>cercaliagl.control.MapControls.METEO</b>: Meteo control button. Value: <code>meteo</code></li>
 *  <li><b>cercaliagl.control.MapControls.MOBILEBAR</b>: Mobile bar control for internal purposes. Value: <code>mobilebar</code></li>
 *  <li><b>cercaliagl.control.MapControls.NAVBAR</b>: Nav bar control for internal purposes. Value: <code>navbar</code></li>
 *  <li><b>cercaliagl.control.MapControls.SCALELINE</b>: Scale line control. Value: <code>scaleline</code></li>
 *  <li><b>cercaliagl.control.MapControls.TRAFFIC</b>: Traffic control. Value: <code>traffic</code></li>
 *  <li><b>cercaliagl.control.MapControls.ZOOM</b>: Zoom control. Value: <code>zoom</code></li>
 * </ul>
 * <br/>
 * Example use for these constants:
 * <br/>
 *
 * ```js
 * const map = new cercaliagl.Map({
 *   target: 'map',
 *   controls: [
 *     cercaliagl.control.MapControls.NAVBAR,
 *     cercaliagl.control.MapControls.ZOOM,
 *     cercaliagl.control.MapControls.CLEAN,
 *     cercaliagl.control.MapControls.METEO
 *   ]
 * };
 * ```
 *
 * @type {Object.<string, string>}
 * @api
 */
var MapControls = {
    ADDRESS: 'address',
    BUILDINGS3D: 'buildings3d',
    CLEAN: 'clean',
    DRAW: 'draw',
    FULLSCREEN: 'fullscreen',
    GAS_STATIONS: 'gasstations',
    INFOMAP: 'infomap',
    ISOCHRONES: 'isochrones',
    LAYER_REGIONS: 'layerregions',
    LAYER_SWITCHER: 'layerswitcher',
    LOGISTICS_RESTRICTIONS: 'logisticsrestrictions',
    LOGO: 'logo',
    METEO: 'meteo',
    MOBILEBAR: 'mobilebar',
    NAVBAR: 'navbar',
    SCALELINE: 'scaleline',
    STREETVIEW: 'streetview',
    TRAFFIC: 'traffic',
    ZBE: 'zbe',
    ZOOM: 'zoom',
};
export default MapControls;
//# sourceMappingURL=MapControls.js.map